import { createContext } from 'react';

const AuthSessionContext = createContext(null);

export default AuthSessionContext;
